import * as React from 'react';
import EDIconButton from '../../IconButton/EDIconButton';
import { CommonPropsAndTypes } from '../../../_Types/StandardComponentProps';

interface IProps {
  onClick: () => void;
  tooltip?: string;
  disabled?: boolean;
  disabledReason?: string;
  noLeftMargin?: boolean;
  noRightMargin?: boolean;
  noTopMargin?: boolean;
  noBottomMargin?: boolean;
  color?: CommonPropsAndTypes.ColorType;
}

/**
 * En knapp menad för att gå bakåt i samma sammanhang
 */
const EDBackChevron: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = (props: IProps) => {
  const { tooltip = 'Föregående', ...rest } = props;
  return (
    <EDIconButton
      color={props.color && undefined}
      tooltip={tooltip}
      {...rest}
      icon="chevron_left"
    />
  );
};

export default EDBackChevron;
